<template>
  <component
    :is="'payback-' + mappedType"
    :added="added"
    :product="product"
  ></component>
</template>

<script>
import PaybackFixKupon from './PaybackFixKupon'
import PaybackExpress from './PaybackExpress'
import PaybackBonusExpress from './PaybackBonusExpress'
import PaybackReverse from './PaybackReverse'
import PaybackReverseProtect from './PaybackReverseProtect'
import PaybackMemoryExpress from './PaybackMemoryExpress'

export default {
  name: 'payback-text-container',
  data() {
    return {
      typeMap: {
        QTE0: 'express',
        QTEB: 'bonus-express',
        QTEF: 'fix-kupon',
        QTEM: 'memory-express',
        QTR0: 'reverse',
        QTRP: 'reverse-protect',
      }
    }
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    added: {
      type: Object,
      required: true
    }
  },
  computed: {
    mappedType() {
      return this.typeMap[this.product.type]
    }
  },
  components: {
    PaybackFixKupon,
    PaybackExpress,
    PaybackBonusExpress,
    PaybackReverse,
    PaybackReverseProtect,
    PaybackMemoryExpress
  }
}
</script>



// WEBPACK FOOTER //
// PaybackTextContainer.vue?3948201b